(function($) {
  $(document).ready(function() {

    // получаем все кнопки навигации
    const tabsButtons = document.querySelectorAll('.nav-item');

    // Проходимся по всем кнопкам
    tabsButtons.forEach(btn => {
      // вешаем на каждую кнопку обработчик события клик
      btn.addEventListener('click', () => {
        // Получаем предыдущую активную кнопку
        const prevActiveItem = document.querySelector('.tab-pane.active');
        // Получаем предыдущую активную вкладку
        const prevActiveButton = document.querySelector('.nav-item.active');

        // Проверяем есть или нет предыдущая активная кнопка
        if (prevActiveButton) {
          //Удаляем класс _active у предыдущей кнопки если она есть
          prevActiveButton.classList.remove('active');
        }

        // Проверяем есть или нет предыдущая активная вкладка
        if (prevActiveItem) {
          // Удаляем класс _active у предыдущей вкладки если она есть
          prevActiveItem.classList.remove('active');
        }
        // получаем id новой активной вкладки, который мы перем из атрибута data-tab у кнопки
        const nextActiveItemId = `#${btn.getAttribute('data-tab')}`;
        // получаем новую активную вкладку по id
        const nextActiveItem = document.querySelector(nextActiveItemId);

        // добавляем класс _active кнопке на которую нажали
        btn.classList.add('active');
        // добавляем класс _active новой выбранной вкладке
        nextActiveItem.classList.add('active');
      });
    });

    if(document.documentElement.clientWidth < 565) {
      // блок преимуществ
      $('.field--name-field-paragraph-box .block-wrapper').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      });
    }

    // менюшка на мобильном
    $('#ffd_show').click(function() {
      $(".ffd_morelist").toggleClass('ffd_showlist');
    });

    // блок формы на страничке Партнерство
    if (window.location.href.includes("/node/94") || window.location.href.includes("/partners")) {
      $(".block--programm-offer").find(".field--name-field-paragraph-title").html("Следующий запрос по&nbsp;1С может принести вам&nbsp;доход");
      $(".block--programm-offer").find(".field--name-field-paragraph-body").html("Расскажите, чем занимаетесь — поможем с&nbsp;первой рекомендацией решений&nbsp;1С");

      // hide table
      $('.practice_block .show_more_table').click(function() {
        $(this).toggleClass('show_more_btn');
        $('.practice_block .block_content').toggleClass('content_show');
      });

      // calculate form
      const slider = document.getElementById('dealSlider');
      const dealAmountDisplay = document.getElementById('dealAmountDisplay');
      const incomeDisplay = document.getElementById('incomeDisplay');
      const PERCENTAGE_RATE = 0.10;
      const formatNumber = (num) => {
        return new Intl.NumberFormat('ru-RU').format(num);
      };
      function calculate() {
        const amount = parseInt(slider.value, 10);
        const min = parseInt(slider.min, 10);
        const max = parseInt(slider.max, 10);
        const income = amount * PERCENTAGE_RATE;

        const percent = ((amount - min) / (max - min)) * 100;
        slider.style.setProperty('--percent', percent + '%');

        dealAmountDisplay.textContent = formatNumber(amount);
        incomeDisplay.textContent = formatNumber(income);
      }
      slider.addEventListener('input', calculate);
      calculate();
    }

  });
})(jQuery);
